(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('Authority', Authority);

    Authority.$inject = ['$resource'];

    function Authority ($resource) {
        var service = $resource('api/authorities', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
